// Legacy audit API shim. The real, BE-driven client lives in `./auditLog.ts`.
// This file is retained for back-compat with older call sites (Dashboard
// timeline, Article activity panel, `recordAuditAction`). It accepts the
// pre-S14 `AuditLogQuery` shape and returns the pre-S14 `AuditLogPage`
// (with legacy `AuditLogEntry` items).

import { auditLogApi } from './auditLog';
import type { AuditLogEntry, AuditLogPage, AuditLogQuery } from '@features/audit/types';

export const auditApi = {
  list(query: AuditLogQuery = {}): Promise<AuditLogPage> {
    return auditLogApi.list(query);
  },

  /**
   * BE writes audit entries automatically from every mutating controller, so
   * the FE-side "append" is a no-op. We keep the signature so legacy callers
   * (`recordAuditAction`) compile without touching every page.
   */
  // eslint-disable-next-line @typescript-eslint/require-await
  async append(_entry: AuditLogEntry): Promise<AuditLogEntry> {
    return _entry;
  },
};

export type { AuditLogEntry, AuditLogPage, AuditLogQuery };
